export default __webpack_public_path__ + "static/sz_en_2-1da30e2bd919071332ad7b453523d44f.mp4";